import React from 'react';
import "./index.less";
import "./lastCircleBtn.less";
var LastCircleBtn = function LastCircleBtn(props) {
  var onClick = props.onClick,
    style = props.style,
    disabled = props.disabled;
  var handleClick = function handleClick(e) {
    if (disabled) return;
    if (onClick !== null && onClick !== undefined) {
      onClick(e);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "iron-circle-mobile-btn iron-circle-btn-left ".concat(disabled ? 'iron-button-disabled' : ''),
    onClick: handleClick,
    style: style
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9462 20.6339C15.8083 20.6346 15.6749 20.5848 15.5712 20.4939L6.96117 13.0289C6.81721 12.9132 6.70105 12.7666 6.62124 12.6C6.54143 12.4335 6.5 12.2511 6.5 12.0664C6.5 11.8817 6.54143 11.6993 6.62124 11.5328C6.70105 11.3662 6.81721 11.2196 6.96117 11.1039L15.5712 3.63891C15.6276 3.58999 15.6932 3.55267 15.7641 3.52909C15.835 3.50551 15.9098 3.49612 15.9843 3.50145C16.0588 3.50679 16.1316 3.52676 16.1984 3.56021C16.2652 3.59366 16.3247 3.63994 16.3737 3.69641C16.4226 3.75288 16.4599 3.81843 16.4835 3.88932C16.5071 3.96021 16.5165 4.03505 16.5111 4.10957C16.5058 4.18409 16.4858 4.25682 16.4524 4.32363C16.4189 4.39043 16.3726 4.44999 16.3162 4.49891L7.70117 11.9589C7.66673 11.9842 7.64342 12.0218 7.63617 12.0639C7.64408 12.1071 7.66712 12.1461 7.70117 12.1739L16.3162 19.6389C16.4288 19.7381 16.4978 19.8778 16.5081 20.0276C16.5184 20.1774 16.4692 20.3252 16.3712 20.4389C16.3186 20.5001 16.2533 20.5492 16.18 20.5829C16.1066 20.6165 16.0269 20.6339 15.9462 20.6339Z",
    fill: "#04AFFF"
  })));
};
LastCircleBtn.defaultPros = {
  onClick: undefined,
  style: undefined,
  disabled: false
};
export default LastCircleBtn;